import { fetcher } from '@commenda/utils';

export async function sendReminder(recipientId: string): Promise<Response> {
  return fetcher(`e-signature/recipients/${recipientId}/reminder`, {
    method: 'POST',
    body: {},
  });
}
